import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

interface Props {
  channelId?: number;
  channelSlug?: string;
}

export function useChannel({
  channelId,
  channelSlug,
}: Props): NonNullable<API.ChannelQuery['channel']> | undefined {
  const { data } = useQuery<API.ChannelQuery, API.ChannelQueryVariables>(
    Queries.channel.getChannel,
    {
      variables: { id: channelId, slug: channelSlug },
      skip: isNil(channelId) && isNil(channelSlug),
    },
  );

  return data?.channel;
}
